module.exports = __webpack_public_path__ + "static/media/suhas.8947d6b9.png";